var map = {
	"./assets/dashboard/bg_alert_count.png": 3183,
	"./assets/logo-anisen-couleur.svg": 5064,
	"./assets/musics/music-round.png": 1701,
	"./assets/musics/playlist.png": 4873,
	"./assets/profiles/avatar.png": 8613
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7148;